export default __webpack_public_path__ + "static/media/CardShrink.da78136e.svg";